module.exports = "https://static.energy5.com/_next/static/images/retail-c3f7f4f6358262b1dba591f6df8745e1.webp";